import React, { ReactElement } from 'react';
import { Field } from 'formik';
import { classNames } from 'primereact/utils';

import s from './publicForm.module.scss';

interface InputProps {
  id: string | null;
  type: string;
  name: string;
  label?: string;
  placeholder: string | null;
  autoComplete?: string;
  as?: string;
  rows?: number;
  error?: string;
}

export default function Input(props: InputProps): ReactElement {
  const { id, type, name, label, placeholder, autoComplete, as, rows, error } =
    props;
  return (
    <div className={s.formGroup}>
      {label && <label htmlFor={name}>{label}</label>}
      <Field
        id={id}
        type={type}
        name={name}
        className={classNames({ [s.formControl]: true, [s.formError]: error })}
        placeholder={placeholder}
        autoComplete={autoComplete}
        as={as}
        rows={rows}
      />
    </div>
  );
}

Input.defaultProps = {
  rows: 0,
  as: null,
  label: null,
  error: null,
  autoComplete: null,
};
